var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrows",
    transform: "translate(-6061 1977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(5876 -2426)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    transform: "translate(185 449)",
    fill: "#0bcfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21915",
    "data-name": "Path 21915",
    d: "M10.5,10.5,23.835,23.835",
    transform: "translate(190.326 454.376)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_22088",
    "data-name": "Path 22088",
    d: "M23.835,10.5V23.835H10.5",
    transform: "translate(6066.326 -1971.624)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/Arrows.ac932ea2a64677cf30d30035144f514e.svg";
export { ForwardRef as ReactComponent };